import React, {useEffect, useRef, useState} from 'react';
import {Button, Form, Row} from 'react-bootstrap';
import HiddenInput from 'components/Form/HiddenInput';
import Input from 'components/Form/Input';
import Select from 'components/Form/Select';
import Switch from 'components/Form/Switch';
import {DEFAULT_CUSTOMER_OPTION, DEFAULT_SITE_OPTION} from 'constants/uiConstants';
import {getCustomerOptions, getSiteOptions} from 'utils/Ui';

export default function LocationForm({
    initialValues, dirty, isValid, isSubmitting, setFieldValue, handleChange, handleSubmit,
    useCustomer, useSite, customers, sites, isEditable, isLoading, onCloseClick
}) {
    const isMounted = useRef(false);
    const [customerOptions, setCustomerOptions] = useState([DEFAULT_CUSTOMER_OPTION]);
    const [siteOptions, setSiteOptions] = useState([DEFAULT_SITE_OPTION]);
    const isDisabled = !isEditable || isLoading;

    useEffect(() => {
        isMounted.current = true;
        let options;
        if (useCustomer) setCustomerOptions(getCustomerOptions(customers));
        if (useSite) {
            options = getSiteOptions(
                sites, useCustomer, initialValues.customer_uuid,
                false, setFieldValue
            );
            setSiteOptions(options);
        }
        return () => isMounted.current = false;
    }, [initialValues, customers, sites]);

    const handleCustomerChange = (e) => {
        handleChange(e);
        setSiteOptions(getSiteOptions(sites, useCustomer, e.target.value, true, setFieldValue));
    };

    return (
        <Form onSubmit={handleSubmit}>
            {useCustomer &&
                <Row>
                    <Select
                      label="Customer" name="customer_uuid"
                      options={customerOptions} onChange={handleCustomerChange}
                      required disabled={isDisabled}
                    />
                </Row>}
            {useSite &&
                <Row>
                    <Select label="Site" name="site_uuid" options={siteOptions} required disabled={isDisabled} />
                </Row>}
            <Row>
                <Input label="Location ID" type="text" name="location_id" required disabled={isDisabled} />
            </Row>
            <Row>
                <Input label="Location name" type="text" name="location_name" required disabled={isDisabled} />
            </Row>
            <Row>
                <Switch label="Active" id="active" name="active" value="1" disabled={isDisabled} />
            </Row>
            <HiddenInput name="id" />
            {isEditable && <Button type="submit" className="btn-form-submit" disabled={!dirty || !isValid || isSubmitting || isDisabled}>Save</Button>}
            <Button type="button" className="btn-form-close" onClick={onCloseClick} disabled={isSubmitting}>Close</Button>
        </Form>
    )
}
